export function scrollToSection(e, sectionId) {
    e.preventDefault();
    const targetElement = document.getElementById(sectionId);

    if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
    }
}
